<div class="container">
    <h1 class="principal-title">Escenarios</h1>
    <div class="principal-summary">Los escenarios se formulan con el propósito de explorar y analizar
        sistemáticamente distintos futuros que abarquen un conjunto más amplio de condiciones que se pueden
        presentar en el país, a fin de reducir la incertidumbre, prever posibles entornos y prepararse antes de
        que las circunstancias ameriten medidas urgentes y drásticas escasamente analizadas. A continuación,
        seleccione algún escenario para obtener mayor información.
    </div>
    <app-carousel [idEventTypeForSlider]="idEvenType"></app-carousel>
    <div class="container-button">
        <a class="btn-foi" *ngIf="t1 && t1.urllistado" href="{{URL}}{{t1.urllistado}}" target="_blank">
            <i class="fa fa-file-pdf-o icon-pdf"></i>Listado de escenarios
        </a>
    </div>
    <div class="normal-text"> A continuación, seleccione algún escenario para obtener mayor información.
    </div>
    <br>
    <div class="row">
        <div class="col-12 col-sm-2"></div>
        <div class="col-6 col-sm-4">
            <li class="li-s activeScene" (click)="listClick($event, 0)" [ngClass]="{'activeScene': selectedItem == 0}">
                <a class="a-s" (click)="change(true)">Escenarios del PEDN</a>
            </li>
        </div>
        <div class="col-6 col-sm-4">
            <li class="li-s " (click)="listClick($event, 1)" [ngClass]="{'activeScene': selectedItem == 1}">
                <a class="a-s" (click)="change(false)">Escenarios de largo plazo</a>
            </li>
        </div>
        <div class="col-12 col-sm-2"></div>
    </div>
    <hr>
    <ng-container *ngIf="selectedItem == 0">
        <div class="row" *ngIf="t1Short">
            <div class="col-12">
                <h4>{{t1Short.longtitle}}</h4>
                <p class="esc_descrip">{{t1Short.summary}}</p>
                <br>
                <!--<div *ngFor="let o of t3Short">
                    <div class="row">
                        <div class="col-sm-3">
                            <img class="img-fluid img-scene" src="{{o.img}}" alt="{{o.shorttitle}}">
                        </div>
                        <div class="col-sm-9">
                            <h4>{{o.longtitle}}</h4>
                            <p>{{o.summary}}</p>
                            <small class="date-scene">Actualizado a {{o.lastUpdated | date:'MMMM yyyy'}}</small>
                        </div>
                    </div>
                    <br>
                </div> -->
                <!--Agregado-->
                <div *ngFor="let o of t3Short">
                    <div class="row row-scene" routerLink="../ficha/{{o.code}}">
                        <div class="col-sm-3">
                            <img class="img-fluid img-scene" src="{{URL}}{{o.img}}" alt="{{o.shorttitle}}">
                        </div>
                        <div class="col-sm-9">
                            <h4>{{o.longtitle}}</h4>
                            <p class="esc_descrip">{{o.summary}}</p>
                            <div class="row">
                                <div class="col-6">
                                    <small class="date-scene">Actualizado a {{o.lastUpdated | date:'MMMM yyyy'}}</small>
                                </div>
                                <div class="col-6 text-right">
                                    <a class="a-scene" routerLink="../ficha/{{o.code}}">Leer más</a>
                                </div>
                            </div>


                        </div>
                    </div>
                    <br>
                </div>
                <!--Aquí termina-->
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="selectedItem == 1">
        <div class="row" *ngIf="t1Long">
            <div class="col-12">
                <h4>{{t1Long.longtitle}}</h4>
                <p class="esc_descrip">{{t1Long.summary}}</p>
                <br>
                <div *ngFor="let o of t3Long">
                    <div class="row row-scene" routerLink="../ficha/{{o.code}}">
                        <div class="col-sm-3">
                            <img class="img-fluid img-scene" src="{{URL}}{{o.img}}" alt="{{o.shorttitle}}">
                        </div>
                        <div class="col-sm-9">
                            <h4>{{o.longtitle}}</h4>
                            <p class="esc_descrip">{{o.summary}}</p>
                            <div class="row">
                                <div class="col-6">
                                    <small class="date-scene">Actualizado a {{o.lastUpdated | date:'MMMM yyyy'}}</small>
                                </div>
                                <div class="col-6 text-right">
                                    <a class="a-scene" routerLink="../ficha/{{o.code}}">Leer más</a>
                                </div>
                            </div>


                        </div>
                    </div>
                    <br>
                </div>
            </div>
        </div>
    </ng-container>
    <br>

    <div class="row">
        <div class="col-12 text-Blue">
            * Revisar documento metodológico sobre escenarios
            <a *ngIf="t1 && t1.urlmetodologico" href="{{URL}}{{t1.urlmetodologico}}" target="_blank">aquí</a>
        </div>
    </div>
</div>